"use client";
import { useEffect, useState } from "react";
import { DESTINATION_LIST } from "../common/Helper";
import { PageLeftArrow, PageRightArrow, SelectArrow } from "../common/Icons";

const DestinationPlaces = () => {
  const [selectedType, setSelectedType] = useState("all");
  const [sortOrder, setSortOrder] = useState("default");
  const [searchTerm, setSearchTerm] = useState(""); //  new state for search
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const types = ["all", ...new Set(DESTINATION_LIST.map((item) => item.type))];

  let filteredList =
    selectedType === "all"
      ? DESTINATION_LIST
      : DESTINATION_LIST.filter((item) => item.type === selectedType);

  // ✅ Search filter by country or place name
  if (searchTerm.trim() !== "") {
    filteredList = filteredList.filter(
      (item) =>
        item.place1.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.place2.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  if (sortOrder === "popular") {
    filteredList = [...filteredList].sort(
      (a, b) => b.popularity - a.popularity
    );
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedType, sortOrder, searchTerm]);

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedList = filteredList.slice(startIndex, endIndex);

  return (
    <div className="2xl:max-w-[1240px] mx-auto px-5 container pt-[98px] pb-[120px] max-lg:py-20 max-md:py-16 overflow-hidden">
      {/* ✅ Search box */}
      <div className=" flex justify-between items-center gap-6 mb-8 xl:mx-5 xl:px-6 border border-[#AAA8A8] rounded-[80px] py-[17.5px] px-6 w-full  max-md:py-3 max-md:px-4 ">
        <input
          type="text"
          placeholder="Search for places, hotels or restaurants"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="outline-none max-md:text-base w-full placeholder:text-[#363636]"
        />

        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
          >
            <path
              d="M22.2188 22.2188L16.1188 16.1104M18.7083 9.85417C18.7083 12.2024 17.7755 14.4545 16.115 16.115C14.4545 17.7755 12.2024 18.7083 9.85417 18.7083C7.5059 18.7083 5.2538 17.7755 3.59333 16.115C1.93285 14.4545 1 12.2024 1 9.85417C1 7.5059 1.93285 5.2538 3.59333 3.59333C5.2538 1.93285 7.5059 1 9.85417 1C12.2024 1 14.4545 1.93285 16.115 3.59333C17.7755 5.2538 18.7083 7.5059 18.7083 9.85417Z"
              stroke="#019FDB"
              stroke-width="1.5625"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>
      <div className="flex max-md:flex-col gap-4 justify-between xl:px-6 mb-[52px] max-lg:mb-10">
        <div>
          <p className="font-medium text-xl leading-[100%] pb-4 max-md:text-lg max-md:pb-2">
            Filter by type of place
          </p>
          <div className="relative w-[441px] max-lg:w-[350px] max-md:w-full">
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="appearance-none py-[17.5px] px-6 pr-12 text-[#363636] text-lg leading-[100%] border border-[#AAA8A8] rounded-[80px] w-full max-md:text-base max-md:py-3 max-md:px-4 outline-none"
            >
              {types.map((type, index) => (
                <option key={index} value={type}>
                  {type === "all"
                    ? "All Types"
                    : type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute right-6 max-md:right-4 top-1/2 transform -translate-y-1/2">
              <SelectArrow />
            </div>
          </div>
        </div>

        <div>
          <p className="font-medium text-xl leading-[100%] pb-4 max-md:text-lg max-md:pb-2">
            Sort by
          </p>
          <div className="relative w-[441px] max-lg:w-[350px] max-md:w-full">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="appearance-none py-[17.5px] px-6 pr-12 text-[#363636] text-lg leading-[100%] border border-[#AAA8A8] rounded-[80px] w-full max-md:text-base max-md:py-3 max-md:px-4 outline-none"
            >
              <option value="default">Sort by</option>
              <option value="popular">Most Popular</option>
            </select>
            <div className="pointer-events-none absolute right-6 max-md:right-4 top-1/2 transform -translate-y-1/2">
              <SelectArrow />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 justify-center">
        {paginatedList.map((item, index) => (
          <div
            key={index}
            className="max-w-[380px] w-full max-xl:max-w-[312px] max-lg:max-w-[352px] border border-black/10 p-5 max-md:p-4 rounded-[20px] hover:border-black/10 hover:shadow-[0px_7px_22.1px_0px_#0000001F] transition-shadow duration-300"
          >
            <div className="flex flex-col items-center">
              <img
                src={item.image}
                alt={item.place2}
                className="rounded-[10px] object-cover pointer-events-none w-[332px] h-[265px]"
              />
              <p className="pt-6 text-lg max-md:text-base font-normal leading-[100%] text-[#010101] max-md:pt-3">
                {item.place1}
              </p>
              <h3 className="pt-[14px] max-md:pt-1.5 font-medium text-2xl max-md:text-xl leading-[100%] text-[#010101]">
                {item.place2}
              </h3>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center gap-4 justify-center pt-[70px] max-lg:pt-14 max-md:pt-10">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="disabled:opacity-50"
          >
            <PageLeftArrow />
          </button>

          <div className="flex gap-2 text-base font-medium text-[#363636]">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`pt-[15.5px] pb-[15px] max-md:py-2 max-md:px-3 px-[22px] border rounded-[8px] font-medium text-2xl max-md:text-base leading-[100%] transition-all duration-300 ${
                  currentPage === i + 1
                    ? "bg-[#019FDB] text-white border-[#019FDB]"
                    : "border-[#363636] hover:bg-[#019FDB] hover:text-white hover:border-[#019FDB]"
                }`}
              >
                {i + 1}
              </button>
            ))}
          </div>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="disabled:opacity-50"
          >
            <PageRightArrow />
          </button>
        </div>
      )}
    </div>
  );
};

export default DestinationPlaces;
